export class StaircaseTags {
  public static readonly StaircaseUnknown = "Staircase Unknown";
  public static readonly StaircaseStraight = "Staircase Straight";
  public static readonly StaircaseL = "Staircase L";
  public static readonly StaircaseU = "Staircase U";
};
